import styled from "@emotion/styled";
import { BASE_COLORS, FONT_SIZES } from "../../../../../emotion-theme";

export const HostContainer = styled.div`
  text-align: right;
`;
export const FileLabel = styled.label`
  padding: 1rem 2rem;
  border: solid 1px ${BASE_COLORS.grey};
  font-size: ${FONT_SIZES.large};
  font-weight: bold;
  border-radius: 4px;
  &:hover {
    cursor: pointer;
  }
`;
export const FileInput = styled.input`
  display: none;
`;
